<template>
  <div id="review-aplikasi-page">
    <h6 class="m-t-0 m-b-20">
      <i class="bi bi-phone"></i> Review Aplikasi
      <i
        class="bi bi-question-circle text-blue"
        v-tooltip.right="{ ref: 'igHelper' }"
      ></i>
      <button
        v-if="isAdmin"
        id="tambah-aplikasi"
        class="btn btn-icon-left btn-success pull-right"
        @click="addAppsData"
      >
        <i class="bi bi-plus"></i> Tambah Aplikasi
      </button>
    </h6>
    <div ref="igHelper" class="tooltip-content">
      <p>
        Daftar <b>Review Aplikasi</b> yang akan dimonitor. Masukan data Aplikasi
        yang ingin Anda monitor datanya pada section ini.
      </p>
    </div>

    <div class="table-wrapper">
      <table
        class="table table-hover table-condensed"
        id="daftar-aplikasi"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>ID Aplikasi</th>
            <th>Nama Aplikasi</th>
            <th>Platform</th>
            <th>Topik</th>
            <th v-if="isAdmin" width="10%">
              <center>Aksi</center>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="is_loading">
            <td colspan="5" align="center">Loading...</td>
          </tr>
        </tbody>
      </table>
    </div>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :data="modal.data"
      :static="true"
    />
  </div>
</template>

<script>
import swal from "sweetalert";
import $ from "jquery";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_apps from "@/views/components/settings/keyword/modal_add_apps.vue";
import modal_edit_apps from "@/views/components/settings/keyword/modal_edit_apps.vue";

export default {
  name: "tab_review_aplikasi",
  components: {
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      tour_steps: [],
      modal: null,
      modal_key: 0,
      table: null,
      topics: null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      data_aplikasi: [],
      is_loading: true,
    };
  },
  methods: {
    addAppsData: function () {
      this.modal = {
        title: "Tambah Aplikasi",
        subtitle: "Silahkan masukan data aplikasi yang ingin dimonitor",
        component: modal_add_apps,
        data: [{ tipe: 1 }],
      };
      this.modal_key++;
    },
    editAppsData: function (data) {
      if (!this.modal) {
        let arr = [];
        arr["app_id"] = data.app_id;
        arr["app_name"] = data.app_name;
        arr["platform"] = data.platform;
        arr["_id"] = data._id.$oid;
        arr["topic"] = data.topic.$oid;
        arr["tipe"] = 1;
        this.modal = {
          title: "Edit Aplikasi",
          subtitle: "Silahkan masukan data aplikasi yang ingin dimonitor",
          component: modal_edit_apps,
          data: arr,
        };
      } else {
        let arr = [];
        arr["app_id"] = data.app_id;
        arr["app_name"] = data.app_name;
        arr["platform"] = data.platform;
        arr["_id"] = data._id.$oid;
        arr["topic"] = data.topic.$oid;
        arr["tipe"] = 1;
        this.modal = {
          title: "Edit Aplikasi",
          subtitle:
            "Silahkan untuk mengubah data aplikasi yang ingin dimonitor",
          component: modal_edit_apps,
          data: arr,
        };
        this.modal_key++;
      }
    },
    deleteAppsData: function (id) {
      swal({
        title: "Apakah anda yakin?",
        text: "Anda akan menghapus Aplikasi ini",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let api = process.env.VUE_APP_API_URL + "review/delete-apps/" + id;
          this.$http
            .delete(api)
            .then(() => {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Aplikasi berhasil dihapus!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
              this.getData();
            })
            .catch(() => {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan ketika menghapus Aplikasi!',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    generateAppsTable: function (id, data) {
      let self = this;
      if (this.isAdmin) {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [
            { data: "app_id" },
            { data: "app_name" },
            { data: "platform" },
            { data: "topik" },
            { data: "action" },
          ],
          columnDefs: [
            {
              render: function (data, type, row) {
                let platform;
                if (row.platform == "playstore") {
                  platform = "Play Store";
                } else {
                  platform = "App Store";
                }

                return platform;
              },
              targets: 2,
            },
            {
              render: function (data, type, row) {
                let topic_name =
                  "<span>" + self.setTopicName(row.topic.$oid) + "</span>";
                return topic_name;
              },
              targets: 3,
            },
            {
              render: function (data, type, row) {
                let btn =
                  '<center><button id="edit-aplikasi" class="btn btn-sm btn-complete ch m-r-5" data-id="' +
                  row.app_id +
                  '"><i class="bi bi-pencil-square"></i></button><button id="hapus-aplikasi" class="btn btn-danger btn-sm del" data-id="' +
                  row.app_id +
                  '"><i class="bi bi-trash"></i></button></center>';
                return btn;
              },
              orderable: false,
              targets: 4,
            },
          ],
        });
      } else {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [
            { data: "app_id" },
            { data: "app_name" },
            { data: "platform" },
            { data: "topic.$oid" },
          ],
        });
      }
    },
    getData: function () {
      this.is_loading = true;
      let api =
        process.env.VUE_APP_API_URL + "review?id_project=" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.data_aplikasi = response.data;
          } else {
            this.data_aplikasi = [];
          }
          this.generateAppsTable("#daftar-aplikasi", this.data_aplikasi);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getTopic: function () {
      let self = this;
      let api =
        process.env.VUE_APP_API_URL + "display-topics/" + this.id_project;
      this.is_loading = true;
      this.$http
        .get(api)
        .then(function (response) {
          self.topics = response.data.socmed;
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getData();
        });
    },
    setTopicName(id) {
      return this.topics[id];
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 1 || user_role == 2) {
        return true;
      }
      return false;
    },
  },
  mounted: function () {
    let self = this;
    self.getTopic();
    self.$("#daftar-aplikasi").on("click", "#edit-aplikasi", function () {
      let id = self.$(this).attr("data-id");
      let data = self.data_aplikasi.filter((el) => el.app_id == id);
      let selected = data[0];
      self.editAppsData(selected);
    });
    self.$("#daftar-aplikasi").on("click", "#hapus-aplikasi", function () {
      let id = self.$(this).attr("data-id");
      let data = self.data_aplikasi.filter((el) => el.app_id == id);
      let selected = data[0];
      self.deleteAppsData(selected._id.$oid);
    });
  },
};
</script>
